<template>
    <div id="authenticateDomain">
        <div class="header mt-5">
            <b class="text-3xl"> Etapa de Autenticação do Domínio </b>
        </div>
        <div class="body mt-5">
            <div class="flex">
                <feather-icon icon="CheckIcon" svgClasses="w-5 h-5" class="p-5"/>
                <p class="align-self-center">
                    Após criar os registros <strong>DNS</strong> e ambos serem validados é necessário <strong>autenticar o seu novo domínio cadastrado</strong> e ele estará hapto para uso.
                    Assim como no processo anterior, <strong>pode ser que a autenticação demora alguns segundos para ser processada</strong>. Clique em <strong>"Autenticar Domínio"</strong> para finalizar a autenticação.
                </p>
            </div>
        </div>
    </div>
</template>
   
<script>
   
export default {
    name: 'AuthenticateDomain',
    data() {
        return {}
    }
}

</script>